import React from 'react';
import LegalLayout from './LegalLayout';
import './legal.css';

const FreeDemoPolicy = () => (
  <LegalLayout title="Free Demo Policy">
    <div className="prose max-w-none">
      <h2 className="text-3xl font-bold text-gray-900 mb-6">Free Demo Policy</h2>
      <p className="text-gray-500 mb-6">Last Updated: August 22, 2026</p>

      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-800 mb-3">What the demo is</h3>
        <p className="text-gray-600 mb-4">
          On request, we may build a limited SmushChat preview using information available on your public website. The purpose is to show how an AI concierge could answer questions about your business before you decide whether to purchase a plan.
        </p>
        <p className="text-gray-600 mb-4">
          The demo is free. It is not a free plan or a free trial, does not start a subscription, and does not require payment information.
        </p>
      </section>

      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-800 mb-3">Data and limitations</h3>
        <p className="text-gray-600 mb-4">
          We use public website content unless you separately provide and authorize additional material. A preview may be temporary, incomplete, and less thoroughly configured than a production chatbot. AI-generated answers can be inaccurate, so you should review the preview and tell us what needs correction.
        </p>
      </section>

      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-800 mb-3">If you choose a paid plan</h3>
        <p className="text-gray-600 mb-4">
          If you approve the preview and purchase a subscription, we can associate the chatbot with that plan and complete setup and onboarding. Setup and onboarding are included with every current paid plan. Features and usage limits are determined by the plan you purchase.
        </p>
        <p className="text-gray-600 mb-4">
          Requesting or reviewing a demo creates no obligation to subscribe. Questions can be sent to <a href="mailto:support@smushlabs.ai">support@smushlabs.ai</a>.
        </p>
      </section>
    </div>
  </LegalLayout>
);

export default FreeDemoPolicy;
